module.exports = __webpack_public_path__ + "shark-example.png?eadf48c442e657c2370f339a6ffef8f1";